import React, { useState } from 'react';
import { Search, ShoppingBag, Menu, X, Heart } from 'lucide-react';
import { BRAND, NAV } from '../mock/mock';
import { useCart } from '../context/CartContext';
import CartDrawer from './CartDrawer';
import AccountMenu from './AccountMenu';

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40" style={{ background: 'var(--gk-cream)', borderBottom: '1px solid #ecdfc7' }}>
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        {/* Left nav (desktop) */}
        <nav className="hidden lg:flex items-center gap-6 text-[13px] font-medium" style={{ color: 'var(--gk-ink)' }}>
          {NAV.slice(0, 4).map(n => (
            <a key={n.label} href={n.href} className="link-underline uppercase tracking-wider hover:text-[color:var(--gk-green)]">{n.label}</a>
          ))}
        </nav>
        <button className="lg:hidden" onClick={() => setMobileOpen(true)} aria-label="Menu">
          <Menu size={24} style={{ color: 'var(--gk-green-dark)' }} />
        </button>

        {/* Logo center */}
        <a href="/" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="absolute inset-0 rounded-full blur-md opacity-40 group-hover:opacity-60 transition-opacity" style={{ background: 'var(--gk-gold)' }} />
            <img src={BRAND.logo} alt="Gaon Ke Masale logo" className="relative h-16 md:h-20 w-16 md:w-20 rounded-full object-cover ring-2 ring-[color:var(--gk-gold)]/60 shadow-md transition-transform duration-500 group-hover:rotate-6" />
          </div>
          <div className="hidden sm:block leading-tight">
            <div className="font-serif text-xl md:text-2xl font-bold" style={{ color: 'var(--gk-green-dark)' }}>GAON KE MASALE</div>
            <div className="text-[10px] md:text-[11px] tracking-[0.25em] uppercase" style={{ color: 'var(--gk-gold-dark)' }}>Pure  ·  Natural  ·  Organic</div>
          </div>
        </a>

        {/* Right nav */}
        <div className="flex items-center gap-4 md:gap-5" style={{ color: 'var(--gk-green-dark)' }}>
          <nav className="hidden lg:flex items-center gap-6 text-[13px] font-medium mr-2">
            {NAV.slice(4).map(n => (
              <a key={n.label} href={n.href} className="link-underline uppercase tracking-wider">{n.label}</a>
            ))}
          </nav>
          <button onClick={() => setSearchOpen(v => !v)} aria-label="Search"><Search size={20} /></button>
          <AccountMenu />
          <button aria-label="Wishlist" className="hidden sm:block"><Heart size={20} /></button>
          <button aria-label="Cart" className="relative" onClick={() => setOpen(true)}>
            <ShoppingBag size={22} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center" style={{ background: 'var(--gk-gold)', color: 'var(--gk-green-dark)' }}>{count}</span>
            )}
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t" style={{ borderColor: '#ecdfc7', background: '#fff' }}>
          <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 flex items-center gap-3">
            <Search size={18} style={{ color: 'var(--gk-green)' }} />
            <input autoFocus placeholder="Search for garam masala, turmeric, cardamom..." className="flex-1 bg-transparent outline-none text-sm" />
            <button onClick={() => setSearchOpen(false)}><X size={18} /></button>
          </div>
        </div>
      )}

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 lg:hidden" style={{ background: 'rgba(42,36,24,0.5)' }} onClick={() => setMobileOpen(false)}>
          <div className="absolute top-0 left-0 h-full w-[80%] max-w-[320px] p-6" style={{ background: 'var(--gk-cream)' }} onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-8">
              <span className="font-serif text-lg font-bold" style={{ color: 'var(--gk-green-dark)' }}>Menu</span>
              <button onClick={() => setMobileOpen(false)}><X size={22} /></button>
            </div>
            <nav className="flex flex-col gap-4">
              {NAV.map(n => (
                <a key={n.label} href={n.href} onClick={() => setMobileOpen(false)} className="text-base uppercase tracking-wider font-medium" style={{ color: 'var(--gk-ink)' }}>{n.label}</a>
              ))}
            </nav>
          </div>
        </div>
      )}

      <CartDrawer />
    </header>
  );
}
